import React, { useEffect, useState } from 'react';
import SlideShow from './SlideShow';
import { getAllTracks } from './adminApi';


export default function Presentation({ slot, onClose }) {
	const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
	const [selectedAnketas, setSelectedAnketas] = useState([]);
	const [music, setMusic] = useState({
		greeting: null,
		meditation: null,
		ending: null,
	});
	const [tracks, setTracks] = useState({
		greeting: [],
		meditation: [],
		ending: [],
	});
	const [finalSlide, setFinalSlide] = useState({ imageUrl: null, trackUrl: null, enabled: false });
	const [start, setStart] = useState(false);

	useEffect(() => {
		getAllTracks()
			.then((data) => {
				setTracks({
					greeting: data.greeting || [],
					meditation: data.meditation || [],
					ending: data.ending || [],
				});
				setFinalSlide({
					imageUrl: data.finalSlideImage || null,
					trackUrl: data.finalSlideTrack || null,
					enabled: !!data.finalSlideEnabled,
				});
			})
			.catch((err) => {
				console.error('Ошибка загрузки треков:', err);
			});
	}, []);

	const toggleAnketa = (id) => {
		setSelectedAnketas((prev) =>
			prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
		);
	};

	const handleStart = () => {
		setStart(true);
	};

	if (start) {
		return (
			<SlideShow
				slot={slot}
				ankets={slot.ankets.filter((a) => selectedAnketas.includes(a.id))}
				music={music}
				finalSlide={finalSlide}
				onClose={onClose}
			/>
		);
	}

	return (
		<div style={{ padding: 20, background: '#fff', border: '1px solid #ccc' }}>
			<h2>Создание презентации</h2>

			<h3>Выберите анкеты:</h3>
			{slot.ankets.map((anketa) => (
				<label key={anketa.id} style={{ display: 'block', marginBottom: 8 }}>
					<input
						type="checkbox"
						checked={selectedAnketas.includes(anketa.id)}
						onChange={() => toggleAnketa(anketa.id)}
					/>{' '}
					{anketa.fullName || '(без имени)'}
				</label>
			))}

			{['greeting', 'meditation', 'ending'].map((section) => (
				<div key={section}>
					<h3>
						Музыка для{' '}
						{{
							greeting: 'Приветствия',
							meditation: 'Медитации',
							ending: 'Завершения',
						}[section]}
						:
					</h3>
					{tracks[section].map((track, i) => (
						<label key={i} style={{ display: 'block' }}>
							<input
								type="radio"
								name={section}
								onChange={() =>
									setMusic((prev) => ({ ...prev, [section]: track.url }))
								}
							/>{' '}
							{track.name}
							<audio
								src={`${API_BASE_URL}/${track.url}`}
								controls
								style={{ display: 'block', marginTop: 4 }}
							/>
						</label>
					))}
				</div>
			))}

			<div style={{ marginTop: 20 }}>
				<button onClick={handleStart} style={{ marginRight: 10 }}>
					Начать
				</button>
				<button onClick={onClose}>Отмена</button>
			</div>
		</div>
	);
}
